<template>
  <section class="summary-section">
    <div class="summary-section__metrics">
      <article
        v-for="counter in summary.counters"
        :key="counter.id"
        class="summary-section__metric-card"
      >
        <span class="summary-section__metric-label">{{ counter.label }}</span>
        <strong class="summary-section__metric-value">{{ counter.value }}</strong>
        <p class="summary-section__metric-detail">{{ counter.detail }}</p>
      </article>
    </div>

    <div class="summary-section__grid">
      <article class="summary-section__panel">
        <div class="summary-section__panel-head">
          <div>
            <h3>Resumen del proceso</h3>
            <p>Estado actual, cronología y avance de cada etapa del proceso de grados.</p>
          </div>
          <span class="summary-section__status" :class="'is-' + summary.statusTone">
            {{ summary.status }}
          </span>
        </div>

        <ol class="summary-section__timeline">
          <li
            v-for="item in summary.timeline"
            :key="item.id"
            class="summary-section__timeline-item"
          >
            <span class="summary-section__dot" :class="'is-' + item.status"></span>

            <div class="summary-section__timeline-body">
              <div class="summary-section__timeline-row">
                <strong>{{ item.title }}</strong>
                <span>{{ item.date }}</span>
              </div>
              <p>{{ item.description }}</p>
            </div>
          </li>
        </ol>
      </article>

      <article class="summary-section__panel">
        <div class="summary-section__panel-head">
          <div>
            <h3>Observación</h3>
            <!-- <p>Recuerda que si no asistirás a la ceremonía, debes confirmar los datos de residencia para el envío de tu paquete de grado.</p> -->
          </div>
        </div>

        <div class="summary-section__observation">
          <article class="summary-section__observation-card">
            <span class="summary-section__observation-tag">ENVIO DEL PAQUETE</span>
            <p>Recuerda que si no vas a asistír a la ceremonía, debes confirmar los datos de residencia para el envío de tu paquete de grado al siguiente correo electrónico:  <strong> documentos.grados@ibero.edu.co</strong></p>
            <p><strong>*No aplica si resides en Bogotá*</strong></p>
            <span class="summary-section__observation-tag summary-section__observation-tag--secondary">DATOS REQUERIDOS</span>
            <p>Por favor registra la siguiente información: Nombre, Cédula, Dirección con nomenclatura, Ciudad o municipio, Departamento, Teléfono.</p>
            <p>En caso de no contar con nomenclatura, indícanos la oficina de Servientrega más cercana a tu lugar de residencia.</p>
          </article>

          <article class="summary-section__observation-card summary-section__observation-card--important">
            <span class="summary-section__observation-tag">IMPORTANTE</span>
            <p>Recuerda que no puedes tener 2 procesos de grado en curso (ordinario - privado), se dará trámite a la primera solicitud registrada.</p>
          </article>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GraduationSummarySection',
  props: {
    summary: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.summary-section {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.summary-section__metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(185px, 1fr));
  gap: 14px;
}

.summary-section__metric-card,
.summary-section__panel {
  background: #fff;
  border: 1px solid var(--ibero-border);
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.summary-section__metric-card {
  border-top: 3px solid var(--ibero-primary);
  padding: 18px;
}

.summary-section__metric-label {
  display: block;
  color: var(--ibero-muted);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.summary-section__metric-value {
  display: block;
  margin-top: 10px;
  color: var(--ibero-text);
  font-size: 26px;
  line-height: 1;
}

.summary-section__metric-detail {
  margin: 10px 0 0;
  color: #4b5563;
  font-size: 13px;
  line-height: 1.6;
}

.summary-section__grid {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(280px, 0.95fr);
  gap: 16px;
}

.summary-section__panel {
  padding: 22px;
}

.summary-section__panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.summary-section__panel-head h3 {
  margin: 0;
  color: var(--ibero-primary);
  font-size: 19px;
  font-weight: 700;
}

.summary-section__panel-head p {
  margin: 8px 0 0;
  color: var(--ibero-muted);
  font-size: 14px;
}

.summary-section__observation {
  margin-top: 14px;
  margin-bottom: 10px;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.summary-section__observation-card {
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid var(--ibero-border);
  border-left: 4px solid var(--ibero-primary);
  background: rgba(162, 39, 60, 0.06);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.summary-section__observation-card--important {
  border-left-color: var(--ibero-accent);
  background: rgba(242, 169, 0, 0.09);
}

.summary-section__observation-tag {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  color: var(--ibero-text);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.summary-section__observation-tag--secondary {
  margin-top: 14px;
}

.summary-section__observation-card p {
  margin: 0;
}

.summary-section__observation-card p + p {
  margin-top: 8px;
}

.summary-section__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  padding: 10px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.summary-section__status.is-success {
  background: rgba(34, 139, 34, 0.12);
  color: #206a20;
}

.summary-section__status.is-warning {
  background: rgba(242, 169, 0, 0.16);
  color: #8a6200;
}

.summary-section__status.is-info {
  background: rgba(162, 39, 60, 0.12);
  color: var(--ibero-primary);
}

.summary-section__timeline {
  margin: 22px 0 0;
  padding: 0;
  list-style: none;
}

.summary-section__timeline-item {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  gap: 14px;
  padding: 16px 0;
}

.summary-section__timeline-item + .summary-section__timeline-item {
  border-top: 1px solid var(--ibero-border);
}

.summary-section__dot {
  width: 12px;
  height: 12px;
  margin-top: 5px;
  border-radius: 50%;
  background: #d1d5db;
  box-shadow: 0 0 0 6px rgba(209, 213, 219, 0.25);
}

.summary-section__dot.is-completed {
  background: #228b22;
  box-shadow: 0 0 0 6px rgba(34, 139, 34, 0.14);
}

.summary-section__dot.is-current {
  background: var(--ibero-primary);
  box-shadow: 0 0 0 6px rgba(162, 39, 60, 0.12);
}

.summary-section__timeline-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.summary-section__timeline-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--ibero-text);
  font-size: 15px;
}

.summary-section__timeline-row span {
  color: var(--ibero-muted);
  font-size: 13px;
}

.summary-section__timeline-body p {
  margin: 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.summary-section__notes {
  margin: 22px 0 0;
  padding-left: 18px;
  color: #4b5563;
  line-height: 1.7;
}

.summary-section__notes li + li {
  margin-top: 10px;
}

@media (max-width: 960px) {
  .summary-section__grid {
    grid-template-columns: 1fr;
  }
}
</style>
